/**
 * Class to hold info for Okta claims
 */
export interface OktaClaim {
  claim: string;
  value: string;
}
